<div id="app-component-view" [attr.data-theme]="isLightTheme ? 'light' : 'dark'" class="tw-w-full tw-min-h-full"
     [style.display]="portalSportsbookService.portalDisplay()">
  <router-outlet></router-outlet>
</div>

@defer (on idle) {
  <router-outlet name="printing"></router-outlet>
}
